import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewComponent } from './review.component';
import { IconModule } from '../icon/icon.module';



@NgModule({
  declarations: [ReviewComponent],
  imports: [
    CommonModule,
    IconModule
  ],
  exports: [ReviewComponent]
})
export class ReviewModule { }
